<template>
  <div>
    <account-list v-show="tabType === 1" @handleShow="handleShow" />
    <account-pay v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
    <account-pay-merchant v-if="tabType === 3" :rowItem="rowItem" :channelType="channelType" @handleShow="handleShow" />
  </div>
</template>

<script>
import accountList from './list.vue'
import accountPay from './pay.vue'
import accountPayMerchant from './payMerchant.vue'
export default {
  components: { accountList, accountPay, accountPayMerchant },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      channelType: ''
    }
  },
  methods: {
    handleShow(row, type, channelType) {
      this.rowItem = { ...row }
      this.tabType = type
      this.channelType = channelType || ''
    }
  }


}
</script>

<style>
</style>